import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Langue } from '@zakat/shared';
import fr from '@/locales/fr.json';

/** Le français est embarqué ; le wolof et l'arabe sont chargés à la demande. */
const loaders: Record<Exclude<Langue, 'fr'>, () => Promise<{ default: Record<string, unknown> }>> = {
  wo: () => import('@/locales/wo.json'),
  ar: () => import('@/locales/ar.json'),
};

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr } },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export async function changeLanguage(lang: Langue): Promise<void> {
  if (lang !== 'fr' && !i18n.hasResourceBundle(lang, 'translation')) {
    const mod = await loaders[lang]();
    i18n.addResourceBundle(lang, 'translation', mod.default, true, true);
  }
  await i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  document.documentElement.dir = i18n.dir(lang);
}

export default i18n;
